var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDEE1",
    width: 32,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#181C32",
    fill: "#181C32",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "m5 9 2 2 5-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.80636b9f0da4cbc5abcb9c1c744e3831.svg";
export { ForwardRef as ReactComponent };